import _ from 'lodash-es';
import {
  core,
  getLayoutVars,
  getGrid,
  getTitle,
  getSiblingOption,
} from './default';
import { getMetrics, computeCore, createLink } from './common';

const singlevalueCore = {
  layout: {
    ...core.layout,
    singlevalue: {
      center: function({ size, spacing, x, y }, meta, instance) {
        let relativeCenter = getSiblingOption(
          instance,
          meta,
          'relativeCenter',
          ['50%', '50%']
        );
        relativeCenter = relativeCenter.map((c) =>
          parseFloat(c.replace('%', ''))
        );

        const gridRight = parseFloat(
          singlevalueCore.layout.grid
            .right({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridLeft = parseFloat(
          singlevalueCore.layout.grid
            .left({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridWidth = 100 - gridRight - gridLeft;

        const gridBottom = parseFloat(
          singlevalueCore.layout.grid
            .bottom({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridTop = parseFloat(
          singlevalueCore.layout.grid
            .top({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridHeight = 100 - gridBottom - gridTop;

        const gridCenter = [gridLeft + gridWidth / 2, gridTop + gridHeight / 2];

        return [
          gridCenter[0] + (gridWidth * (relativeCenter[0] - 50)) / 100 + '%',
          gridCenter[1] + (gridHeight * (relativeCenter[1] - 50)) / 100 + '%',
        ];
      },
      radius: function({ size, spacing, x, y }, meta, instance) {
        const gridRight = parseFloat(
          singlevalueCore.layout.grid
            .right({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridLeft = parseFloat(
          singlevalueCore.layout.grid
            .left({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridBottom = parseFloat(
          singlevalueCore.layout.grid
            .bottom({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridTop = parseFloat(
          singlevalueCore.layout.grid
            .top({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );
        const gridWidth = 100 - gridRight - gridLeft;
        const gridHeight = 100 - gridBottom - gridTop;
        return Math.max(gridWidth, gridHeight) + '%';
      },
    },
  },
};

function getSingleValueVars(sample, size) {
  const {
    center: [centerX, centerY],
  } = sample.series[0];
  return {
    ...getLayoutVars(size),
    singlevalue: {
      relativeCenter: [centerX, centerY],
    },
  };
}

function getSingleValue(arg, vars, core) {
  return {
    center: createLink(
      { ...arg, path: 'layout.singlevalue.center' },
      vars,
      core
    ),
    radius: createLink(
      { ...arg, path: 'layout.singlevalue.radius' },
      vars,
      core
    ),
    relativeCenter: createLink('layout.singlevalue.relativeCenter', vars),
  };
}

export default {
  compute: (...args) => computeCore(singlevalueCore, ...args),
  sample: function(sample, template, size) {
    const m = getMetrics(size);

    if (m.cols == 1 && m.rows == 1) {
      return sample;
    }

    if (!sample.vars) {
      sample.vars = {};
    }

    sample.vars.layout = getSingleValueVars(sample, size);
    const vars = sample.vars;

    sample.chartName = `Multi-SingleValue ${m.cols}x${m.rows}`;
    sample.aspectRatio = `${m.cols}:${m.rows}`;

    if (sample.legend) {
      sample.legend.show = false;
    }

    const serie = sample.series[0];
    sample.series = [];

    const title = sample.title[0];
    sample.title = [];

    const grid = (sample.grid && sample.grid[0]) || {};

    sample.grid = [];

    for (let x = 0; x < m.cols; x++) {
      for (let y = 0; y < m.rows; y++) {
        const arg = { x, y, size, type: 'singlevalue' };

        const g = getGrid(arg, vars, singlevalueCore);
        const dx = 100 / m.cols;
        const dy = 100 / m.rows;
        const dr = Math.max(dx, dy);
        const dmax = Math.max(dx, dy);
        const dmin = Math.min(dx, dy);

        sample.grid.push({
          ...grid,
          ...g,
        });

        let s = {
          ...serie,
          type: 'multisinglevalue',
          originalType: 'gauge',
          name: `${template}-${x + 1}-${y + 1}`,
          data: {
            name: `Value ${x + 1}:${y + 1}`,
            value: `${x + 1}${y + 1}`,
          },
          ...getSingleValue(arg, vars, singlevalueCore),
        };
        s.detail.fontSize = `${Math.max(dmin / 2, 10)}`;
        s.detail.padding = [dmin / 4, dmin / 4, dmin / 4, dmin / 4];
        s.title.fontSize = `${Math.max(dmin / 2, 10)}`;

        sample.series.push(s);

        sample.title.push({
          ...title,
          ...getTitle(arg, vars, singlevalueCore),
          padding: 0,
        });
      }
    }

    return sample;
  },
};
